<template>
  <div>
    <!-- mean it's not a V5 portal yet -->
    <v-alert v-if="isMigrationSucess" type="success">
      La migration a bien été effectuée.
    </v-alert>
    <v-alert v-if="isMigrationError" type="danger">
      Une erreur est survenue lors de la migration.
    </v-alert>

    <v-row v-if="clientPortal.portal != '3'">
      <v-col cols="12">
        <v-card>
          <v-card-title>Portail v4</v-card-title>
          <v-card-text>
            <v-alert type="error">
              Attention Portail Client en v4, la configuration se fait
              <a
                :href="
                  'https://passman01.wifipass.org/w2a/backoffice.php/application/page/client/' +
                  clientPortal.description +
                  '/client-' +
                  clientPortal.id +
                  '/?target=/w2a/backoffice.php/client_environment/' +
                  clientPortal.id +
                  '/page&summaryType=home'
                "
                target="_blank"
                >ici</a
              >
            </v-alert>
            <div
              v-if="
                clientPortal.portal == 2 &&
                clientPortal.isInherit == false &&
                clientPortal.isBuiltin == false
              "
            >
              <v-btn
                @click="openConfirmDialogForV4 = true"
                color="primary"
                :disabled="
                  isClientPortalMigrable != null &&
                  (isClientPortalMigrable.facebook ||
                    isClientPortalMigrable.pms)
                "
                >Migrer le portail en V5</v-btn
              >
              <p
                v-if="
                  isClientPortalMigrable != null &&
                  isClientPortalMigrable.facebook
                "
              >
                Le portail est configuré avec Facebook, option non supportée sur
                les V5.
              </p>
              <p
                v-if="
                  isClientPortalMigrable != null && isClientPortalMigrable.pms
                "
              >
                Le portail est configuré avec la PMS, option non supportée sur
                les V5.
              </p>
            </div>
            <div
              v-else-if="
                clientPortal.portal == 2 && clientPortal.isBuiltin == true
              "
            >
              <migrate-client-portal-built-in
                :isClientPortalMigrableParent="isClientPortalMigrable"
                :clientPortal="clientPortal"
              ></migrate-client-portal-built-in>
            </div>
            <div
              v-else-if="
                clientPortal.portal == 2 && clientPortal.isInherit == true
              "
            >
              <v-alert type="warning"> Il faut migrer le groupe. </v-alert>
            </div>
            <div v-else>
              <v-btn @click="openConfirmDialogForV3 = true" color="primary"
                >Migrer le portail de V3 vers V5</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <confirm-dialog
      :open.sync="openConfirmDialogForV3"
      v-on:cancel="openConfirmDialogForV3 = false"
      v-on:confirm="migrateClientPortalV3ToV5(clientPortal.id)"
    >
      <template #title> Demande de confirmation </template>
      <slot name="confirm-text">
        Êtes-vous sûr.e de vouloir migrer ce portail ?
      </slot>
    </confirm-dialog>
    <confirm-dialog
      :open.sync="openConfirmDialogForV4"
      v-on:cancel="openConfirmDialogForV4 = false"
      v-on:confirm="migrateClientPortal(clientPortal.id)"
    >
      <template #title> Demande de confirmation </template>
      <slot name="confirm-text">
        Êtes-vous sûr.e de vouloir migrer ce portail ?
      </slot>
    </confirm-dialog>
  </div>
</template>
<script>
import { defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import { useMigrationPortal } from "@/composables/migation-portal";
import MigrateClientPortalBuiltIn from "@/components/ClientPortal/MigrateClientPortalBuiltIn.vue";
import ConfirmDialog from "../General/ConfirmDialog";

export default defineComponent({
  components: {
    ConfirmDialog,
    MigrateClientPortalBuiltIn,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const {
      migrationPortalData,
      migrateClientPortal,
      migrateClientPortalV3ToV5,
      clientPortalIsMigrable,
    } = useMigrationPortal();

    const openConfirmDialogForV3 = ref(false);
    const openConfirmDialogForV4 = ref(false);

    onMounted(() => {
      clientPortalIsMigrable(props.clientPortal.id);
    });

    return {
      ...toRefs(migrationPortalData),
      migrateClientPortal,
      migrateClientPortalV3ToV5,
      openConfirmDialogForV3,
      openConfirmDialogForV4,
    };
  },
});
</script>
